'use client';
import { useRelatedProducts } from '@eliadmin/core/src/hooks/products/use-related-products';
import { RelatedProductsStatus } from '@eliadmin/core/src/components/product/detail/related-products-status';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { ProductsContainerView } from '../product-container-view';
import { CarouselProvider } from '@eliadmin/core/src/components/ui/carousel-context';

export const ProductRecomendedProducts = () => {
  const { t } = useTranslations();
  const templateSettings = useGlobalStore(s => s.templateSettings);
  const product = useVariantsStore(s => s.product);

  const related = useRelatedProducts(product.slug);
  const relatedProducts = related.products;
  const isRecommendedAccessoriesEnabled =
    !!templateSettings.product_detail?.product_recommended_accessories?.enabled;
  const accessories = isRecommendedAccessoriesEnabled ? (product.accessories ?? []) : [];

  const hasRelatedProducts = relatedProducts.length > 0;
  const hasAccessories = accessories.length > 0;

  // Display nothing if:
  // - there are no related products AND
  // - (recommended accessories are disabled OR there are no accessories)
  if (
    !hasRelatedProducts &&
    (!isRecommendedAccessoriesEnabled || !hasAccessories) &&
    !related.isLoading &&
    !related.isError
  ) {
    return null;
  }

  // Merge accessories (first) + related products and dedupe by id
  const mergedProducts = [...accessories, ...relatedProducts];

  const seenIds = new Set<number | string>();
  const productsToShow = mergedProducts.filter((item: any) => {
    const id = item?.id;
    if (id == null) return false;
    if (seenIds.has(id)) return false;
    seenIds.add(id);
    return true;
  });

  return (
    <>
      {' '}
      <CarouselProvider>
        <ProductsContainerView
          products={productsToShow as any}
          title={'Podobné produkty'}
          description={'Mohlo by vás ešte zaujímať.'}
          variant={'carousel'}
          className={{
            section: 'pb-12 pt-6 sm:pb-16 sm:pt-8 md:pb-20 md:pt-10 lg:pb-24 lg:pt-12',
          }}
        />
      </CarouselProvider>{' '}
      <div className="mx-auto w-full max-w-screen-2xl px-4">
        <RelatedProductsStatus
          loading={related.isLoading}
          error={related.isError}
          retry={() => {
            void related.refetch();
          }}
        />
      </div>{' '}
    </>
  );
};
